<template>
  <kq-container backgroundColor="#ebf1f6" :isBorder="false" style="z-index: 1000">
    <div class="flex-column-center margin-b-xl" @click="back">
      <img class="margin-tb-lg" style="width: 60px; height: 60px" src="../../assets/image/icon-logo.png" alt="logo" />
      <div class="margin-b-lg" style="user-select: none">
        <i class="el-icon-info margin-r-sm"></i>
        <span>请输入关键字搜索页面</span>
      </div>
      <el-input
        ref="searchInput"
        v-model="searchKeyword"
        class="width-40"
        placeholder="搜索页面"
        prefix-icon="el-icon-search"
        clearable
        @input="handleSearch"
        @click.stop.native
      />
    </div>
    <el-scrollbar v-if="searchResults.length > 0" class="flex-1 scroll-hide-x">
      <div
        class="flex-row-center-v search-result-item padding bg-white"
        v-for="item in searchResults"
        :key="item.path"
        @click="handleMenuClick(item)"
      >
        <i class="el-icon-document text-sl color-light padding-r"></i>
        <div class="flex-column">
          <span class="margin-b-sm text-bold text-main">{{ item.title }}</span>
          <span class="text-light">{{ item.path }}</span>
        </div>
      </div>
    </el-scrollbar>
  </kq-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SearchMenu',
  data() {
    return {
      searchKeyword: '',
      searchResults: [],
      loading: false
    }
  },
  computed: {
    ...mapState('menu', ['menus']),

    flattenMenus() {
      const result = []
      this.flatten(result, this.menus)
      return result
    }
  },
  mounted() {
    // 组件挂载时初始化搜索结果为所有菜单
    this.searchResults = [...this.flattenMenus]
    // 自动聚焦到搜索框
    this.$nextTick(() => {
      this.$refs.searchInput.focus()
    })
  },
  methods: {
    /**
     * 返回上一级
     */
    back() {
      this.$emit('back')
    },

    /**
     * 递归函数，用于遍历菜单树
     */
    flatten(result, menuItems, title = '') {
      if (!menuItems || !Array.isArray(menuItems)) return

      menuItems.forEach(menu => {
        if (!menu || menu.path === '/') return

        const currentTitle = `${title ? `${title}/` : ''}${menu.title}`

        // 添加当前菜单到结果数组
        result.push({
          path: menu.path,
          title: currentTitle
        })

        // 递归处理子菜单
        if (menu.children && menu.children.length > 0) {
          this.flatten(result, menu.children, currentTitle)
        }
      })
    },

    /**
     * 处理搜索
     */
    handleSearch() {
      if (!this.searchKeyword) {
        this.searchResults = [...this.flattenMenus]
        return
      }

      this.loading = true

      // 简单防抖
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        const keyword = this.searchKeyword.toLowerCase()
        this.searchResults = this.flattenMenus.filter(
          item => item.title.toLowerCase().includes(keyword) || item.path.toLowerCase().includes(keyword)
        )
        this.loading = false
      }, 300)
    },

    /**
     * 处理菜单点击
     */
    handleMenuClick(item) {
      this.back()
      if (this.isExternal(item.path)) {
        window.open(item.path, '_blank')
        return
      }
      this.$router.push(item.path)
    },

    /**
     * 路径是否为网页
     */
    isExternal(path) {
      return path && /^(https?:|mailto:|tel:)/.test(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.search-result-item:hover {
  cursor: pointer;
  user-select: none;
  background-color: $color-bg-hover;
}
</style>
